import { settingsTexts } from 'consts/text';
import { HistoryChangeType, LabelMapper } from 'types';

export const historyChangeTypeLabels: LabelMapper<HistoryChangeType> = {
    UPDATE: settingsTexts.historyOfChanges.historyOfChangesActivity.UPDATE,
    CREATE: settingsTexts.historyOfChanges.historyOfChangesActivity.CREATE,
    DELETE: settingsTexts.historyOfChanges.historyOfChangesActivity.DELETE,
};
